<script lang="ts" setup>
  import { chevronBack } from 'ionicons/icons'

  const router = useIonRouter()

  /**
   * Back button default behaviour is to navigate back in the router history stack.
   * A custom event can be passed to override default behaviour.
   */
  const props = withDefaults(
    defineProps<{
      backButtonFunc?: () => void
    }>(),
    {
      backButtonFunc: undefined
    }
  )

  function navigateBack() {
    router.canGoBack() ? router.back() : router.replace('/home')
  }

  function handleBackButton() {
    if (props.backButtonFunc) {
      props.backButtonFunc()
    } else {
      navigateBack()
    }
  }
</script>

<template>
  <ion-icon
    :icon="chevronBack"
    aria-label="Go back"
    class="back-button"
    tabindex="0"
    @click="handleBackButton"
    @keydown.enter="handleBackButton"
  />
</template>

<style lang="scss" scoped>
  .back-button {
    font-size: 24px;
    cursor: pointer;
  }
</style>
